import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService, AppConfiguration } from '../service/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class FlowableService
{
  private appConfig: AppConfiguration;

  constructor(private http: HttpClient,
    private appConfigService: AppConfigService)
  {
    this.appConfig = this.appConfigService.getConfig();
  }

  public createProcess(bpm: any): Observable<any>
  {
    return this.http.post<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/models`, bpm, { withCredentials: true });
  }

  public getModel(modelId: string): Observable<any>
  {
    return this.http.get<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/models/${modelId}`, { withCredentials: true });
  }

  public getModelSource(modelId: string): Observable<any>
  {
    return this.http.get<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/models/${modelId}/editor/json`,
      { withCredentials: true });
  }

  public updateModelSource(modelId: string, model: any): Observable<any>
  {
    const options = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      withCredentials: true
    };

    // Need to convert JSON to form urlencoded
    let modelData = '';
    for (const key in model)
    {
      if ({}.hasOwnProperty.call(model, key))
      {
        switch (key)
        {
          // Model property need to be stringify
          case 'model':
            modelData += `json_xml=${encodeURIComponent(JSON.stringify(model.model))}&`;
            break;
          default:
            modelData += `${encodeURIComponent(key)}=${encodeURIComponent(model[key])}&`;
            break;
        }
      }
    }

    return this.http.post<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/models/${modelId}/editor/json`,
      modelData, options);
  }

  public createApp(app: any): Observable<any>
  {
    return this.http.post<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/models`, app, { withCredentials: true });
  }

  public updateApp(id: string, app: any): Observable<any>
  {
    return this.http.put<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/app-definitions/${id}`,
      app, { withCredentials: true });
  }

  public getDeployedBpmnByAppKey(appKey: string): Observable<any>
  {
    return this.http.get<any>(
      `${this.appConfig.flowable.baseUrl}/flowable-task/app/rest/process-definitions?latest=true&appDefinitionKey=${appKey}`,
      { withCredentials: true });
  }

  public exportModel(id: string): Observable<any>
  {
    return this.http.get<any>(`${this.appConfig.flowable.baseUrl}/flowable-modeler/app/rest/app-definitions/${id}/export`,
      { withCredentials: true });
  }

  public generateZip(appId: string, bpmId: string): Observable<any>
  {
    return this.http.get<any>(`/flowable/export/${appId}/${bpmId}`);
  }
}
